import { Box, Flex } from 'rebass'
import { borders } from 'styled-system'

const NavCaret = props => {
  return (
    <Flex
      {...props}
      css={[
        `
                box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
                border-radius: 50%;
                width: ${props.size || '30px'} ;
                height: ${props.size || '30px'};
                cursor: pointer;
                transition: all .1s;
                ${
    !props.disabled
      ? `&:hover {
                    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
                };`
      : ''
    }
                ${props.disabled ? `cursor: not-allowed;` : ''}
                `,
        borders
      ]}>
      <Box
        fontSize={`${props.size ? (props.size - 6) : 23}px`}
        color={props.disabled ? 'grey.default' : 'primary'}
        className={`zen-icon_ic_arrow-${props.direction === 'left' ? 's_left' : 's_right'}`}
        css={[`
          ::before {
            font-size: ${props.iconSize ? props.iconSize : '18px'};
            margin-left: 1px;
          }
        `]}
        style={props.style}
      />
    </Flex>
  )
}

NavCaret.defaultProps = {
  border: 1,
  justifyContent: 'center',
  alignItems: 'center',
  borders: 'primary'
}

export default NavCaret
